module.exports = __webpack_public_path__ + "img/menu_drinks_new.961835a4.png";